import { Dimensions, LayoutAnimation, UIManager, Platform } from 'react-native';

if (Platform.OS === 'android') {
  if (UIManager.setLayoutAnimationEnabledExperimental) {
    UIManager.setLayoutAnimationEnabledExperimental(true);
  }
}

// Dark mode colors (original)
export const DARK_COLOURS = {
  MAIN_BG: '#12141a',
  MAIN: '#191D24',
  BACKGROUND: '#191D24',
  PRIMARY: '#17151D',
  SECONDARY: '#0676ED',
  TEXTWHITE: '#F8FAFF',

  BG: '#12141a', 
  BG0: '#151A20',
  BG1: '#181C22',
  BG2: '#20242B',
  BG3: '#35373C',
  BG4: '#4B4E54',
  BG5: '#686868',
  TEXTCOLOR: '#FFFFFF',
  PLACEHOLDER: '#797979',
  TEXTINPUT: '#0720D5',
  PURPLE: '#8F6FFB',
  BUTTON2: '#252B35',
  DESELECTEDCOLOR: '#EEF2FC',
  OFFWHITE: '#C7C7D2',
  WHITE: '#FFF',
  GREEN: '#07D55D',
  GREENCOMPLETE: 'rgba(55, 255, 86, 0.4)',
  ORANGE: '#FF8807',
  YELLOW: '#FFD76E',
  RED: '#E35B5B',
  RED2: '#FF5F5F',
  BLUE: '#8995F9',
  BLUE2: 'rgb(97, 109, 240)',
  BLUEHOVER: 'rgb(47, 115, 251)',
  BLUE_TRANSPARENT: 'rgba(47, 115, 251, 0.15)',
  BLUE_LIGHT: '#ADD8E6',
  // Semantic accents - Projects lean blue/purple, Tasks lean orange
  PROJECT_ACCENT: '#8995F9',
  PROJECT_ACCENT_TRANSPARENT: 'rgba(47, 115, 251, 0.15)',
  TASK_ACCENT: '#FF8807',
  TASK_ACCENT_TRANSPARENT: 'rgba(255, 136, 7, 0.18)',
  GRAY: '#808080',
  WHITE_TRANSPARENT: 'rgba(255, 255, 255, 0.015)',
  WHITE_TRANSPARENT1: 'rgba(255, 255, 255, 0.1)',
  WHITE_TRANSPARENT2: 'rgba(255, 255, 255, 0.08)',
  WHITE_TRANSPARENT3: 'rgba(255, 255, 255, 0.06)',
  WHITE_TRANSPARENT4: 'rgba(212, 212, 212, 0.04)',
  WHITE_TRANSPARENT5: 'rgba(0, 0, 0, 0.05)',
  WHITE_TRANSPARENT7: 'rgba(212, 212, 212, 0.03)',
  WHITE_TRANSPARENT8: 'rgba(212, 212, 212, 0.015)',
  WHITE_TRANSPARENT9: 'rgba(255, 255, 255, 0.8)',
  WHITE_TRANSPARENT99: 'rgba(255, 255, 255, 0.9)',
  WHITE_TRANSPARENT10: 'rgba(255, 255, 255, 0.5)',
  WHITE_TRANSPARENT6: 'rgba(0, 0, 0, 0.015)',
  BACK_TRANSPARENT: 'rgba(0, 0, 0, 0.1)',
  BACK_TRANSPARENT2: 'rgba(255, 255, 255, 0.37)',
  BLACK_TRANS: 'rgba(52, 52, 52, 0.2)',
  BLACK: '#252525',
  RED_TRANS: 'rgba(255, 95, 95, 0.05)',
  DANGER: '#FF3B30',
};

// Light mode colors - optimized for readability
// Layered depth: greyer background at back, progressively lighter layers on top
export const LIGHT_COLOURS = {
  MAIN_BG: '#C8CDD4',           // Greyer background (furthest back)
  MAIN: '#FFFFFF',              // White for cards/panels on top
  BACKGROUND: '#D0D5DC',        // Slightly lighter than MAIN_BG
  PRIMARY: '#FFFFFF',           // White for elevated surfaces
  SECONDARY: '#0558B8',
  TEXTWHITE: '#0F0F1A',

  BG: '#C8CDD4',                // Base layer - grey
  BG0: '#C8CDD4',               // Layer 1 - lighter
  BG1: '#EBEEF2',               // Layer 2 - even lighter
  BG2: '#F2F4F7',               // Layer 3 - very light
  BG3: '#F8F9FB',               // Layer 4 - almost white
  BG4: '#FAFBFC',               // Layer 5 - near white
  BG5: '#FFFFFF',               // Top layer - white
  TEXTCOLOR: '#0F0F1A',           // Darker - almost black for main text
  PLACEHOLDER: '#6B7280',          // Darker gray for better visibility
  TEXTINPUT: '#0720D5',
  PURPLE: '#7C3AED',               // Slightly darker purple
  BUTTON2: '#E8ECF0',
  DESELECTEDCOLOR: '#1F2937',      // Darker for better contrast
  OFFWHITE: '#374151',             // Much darker gray for secondary text
  WHITE: '#FFFFFF',
  GREEN: '#059669',                // Darker green for better contrast
  GREENCOMPLETE: 'rgba(5, 150, 105, 0.2)',
  ORANGE: '#EA580C',               // Darker orange
  YELLOW: '#D97706',               // Darker amber/yellow for visibility
  RED: '#DC2626',                  // Darker red
  RED2: '#EF4444',
  BLUE: '#4338CA',                 // Darker indigo-blue
  BLUE2: '#4F46E5',
  BLUEHOVER: '#3730A3',
  BLUE_TRANSPARENT: 'rgba(67, 56, 202, 0.15)',
  BLUE_LIGHT: '#EEF2FF',
  // Semantic accents - Projects lean blue/purple, Tasks lean orange
  PROJECT_ACCENT: '#4338CA',
  PROJECT_ACCENT_TRANSPARENT: 'rgba(67, 56, 202, 0.15)',
  TASK_ACCENT: '#EA580C',
  TASK_ACCENT_TRANSPARENT: 'rgba(234, 88, 12, 0.15)',
  GRAY: '#6B7280',                 // Darker gray
  // White borders for light mode - creates nice separation on grey backgrounds
  WHITE_TRANSPARENT: 'rgba(255, 255, 255, 0.5)',
  WHITE_TRANSPARENT1: 'rgba(255, 255, 255, 0.7)',
  WHITE_TRANSPARENT2: 'rgba(255, 255, 255, 0.6)',
  WHITE_TRANSPARENT3: 'rgba(255, 255, 255, 0.8)',
  WHITE_TRANSPARENT4: 'rgba(255, 255, 255, 0.55)',
  WHITE_TRANSPARENT5: 'rgba(255, 255, 255, 0.6)',
  WHITE_TRANSPARENT7: 'rgba(255, 255, 255, 0.5)',
  WHITE_TRANSPARENT8: 'rgba(255, 255, 255, 0.4)',
  WHITE_TRANSPARENT9: 'rgba(255, 255, 255, 0.9)',
  WHITE_TRANSPARENT99: 'rgba(255, 255, 255, 0.95)',
  WHITE_TRANSPARENT10: 'rgba(255, 255, 255, 0.75)',
  WHITE_TRANSPARENT6: 'rgba(255, 255, 255, 0.4)',
  BACK_TRANSPARENT: 'rgba(255, 255, 255, 0.6)',
  BACK_TRANSPARENT2: 'rgba(255, 255, 255, 0.8)',
  BLACK_TRANS: 'rgba(255, 255, 255, 0.65)',
  BLACK: '#0F0F1A',                // Darker black
  RED_TRANS: 'rgba(220, 38, 38, 0.1)',
  DANGER: '#DC2626',
};

// Helper function to get theme-aware colors
export const getThemeColours = (isDark = true) => {
  return isDark ? DARK_COLOURS : LIGHT_COLOURS;
};

// Default export - dark mode for backwards compatibility
export const APP_COLOURS = DARK_COLOURS;

export var CustomLayoutSpring = {
  duration: 400,
  create: {
    type: LayoutAnimation.Types.spring,
    property: LayoutAnimation.Properties.opacity,
    springDamping: 1,
  },
  update: {
    type: LayoutAnimation.Types.spring,
    property: LayoutAnimation.Properties.opacity,
    springDamping: 0.9,
  },
  // delete: {
  //   type: LayoutAnimation.Types.spring,
  //   property: LayoutAnimation.Properties.opacity,
  //   springDamping: 0.9,
  // },
};

export const screenWidth = Math.round(Dimensions.get('window').width);
export const screenHeight = Math.round(Dimensions.get('window').height);

export function StatusColour(d) {
  let color = '';
  let options = {
    online: APP_COLOURS.GREEN,
    busy: APP_COLOURS.ORANGE,
    'On lunch': APP_COLOURS.BLUE,
    offline: APP_COLOURS.RED2,
  };
  color = typeof options[d] !== 'undefined' ? options[d] : 'transparent';
  return color;
}

export const PROJECTSTATUS = [
  {
    type: 1,
    status: 'Urgent',
    color: APP_COLOURS.RED2,
    description: 'Task or project needs immediate attention or action.',
  },
  {
    type: 2,
    status: 'Attention Required',
    color: APP_COLOURS.ORANGE,
    description: 'Custom status entered by the user.',
  },

  {
    type: 4,
    status: 'In Progress',
    color: APP_COLOURS.YELLOW,
    description: 'Task or project is currently underway.',
  },
  {
    type: 5,
    status: 'Awaiting',
    color: APP_COLOURS.ORANGE,
    description: 'Task or project is temporarily paused.',
  },
  {
    type: 6,
    status: 'Paused',
    color: 'grey',
    description: 'Task or project is behind its intended schedule.',
  },
  {
    type: 7,
    status: 'Completed',
    color: APP_COLOURS.GREEN,
    description: 'Task or project has been successfully finished.',
  },
  {
    type: 8,
    status: 'Published',
    color: APP_COLOURS.GREENCOMPLETE,
    description: 'Published',
  },
  {
    type: 9,
    status: 'Ongoing',
    color: '#F47FC0',
    description: 'Task or project is behind its intended schedule.',
  },

  {
    type: 10,
    status: 'Under Review by client',
    color: APP_COLOURS.BLUE,
    description: 'Task or project is being assessed or examined.',
  },

  {
    type: 11,
    status: 'Cancelled',
    color: APP_COLOURS.RED,
    description: 'Task or project has been terminated before completion.',
  },
  {
    type: 12,
    status: 'Not Started',
    color: 'white',
    description: 'Task or project has not begun.',
  },
  {
    type: 13,
    status: 'Scheduled',
    color: APP_COLOURS.WHITE_TRANSPARENT5,
    description: 'Task or project has not begun.',
  },
  {
    type: 13,
    status: 'Awaiting Approval',
    color: APP_COLOURS.BLUE,
    description: 'Task or project has not begun.',
  },
  {
    type: 14,
    status: 'Planning',
    color: '#E8E8E8',
    description: 'Task or project has not begun.',
  },
  {
    type: 15,
    status: 'Design',
    color: APP_COLOURS.BG2,
    description: '',
  },
  {
    type: 16,
    status: 'Copy',
    color: APP_COLOURS.YELLOW,
    description: '',
  },
  {
    type: 17,
    status: 'Approved',
    color: APP_COLOURS.BLUE,
    description: '',
  },
  {
    type: 18,
    status: 'Pending',
    color: APP_COLOURS.GRAY,
    description: '',
  },
  {
    type: 18,
    status: 'pending',
    color: '#E8E8E8',
    description: '',
  },
  {
    type: 19,
    status: 'Delayed',
    color: APP_COLOURS.ORANGE,
    description: 'Task or project is behind its intended schedule.',
  },
];

export const LISTIGSTATUS = [
  {
    type: 1,
    status: 'Pending',
    color: '#E8E8E8',
    description: 'Task or project needs immediate attention or action.',
  },
  {
    type: 2,
    status: 'In Progress',
    color: APP_COLOURS.YELLOW,
    description: 'Custom status entered by the user.',
  },
  {
    type: 3,
    status: 'Review',
    color: APP_COLOURS.BLUE,
    description: '',
  },
  {
    type: 4,
    status: 'Complete',
    color: APP_COLOURS.GREEN,
    description: '',
  },
];

export const PERFORMANCESTATUS = [
  {
    type: 1,
    status: 'Strategy',
    color: APP_COLOURS.BLUE,
    description: 'Task or project needs immediate attention or action.',
  },

  {
    type: 2,
    status: 'Awaiting Brand Approval',
    color: APP_COLOURS.BLUE,
    description: '',
  },
  {
    type: 3,
    status: 'In Progress',
    color: APP_COLOURS.YELLOW,
    description: 'Custom status entered by the user.',
  },
  {
    type: 4,
    status: 'Complete',
    color: APP_COLOURS.GREEN,
    description: '',
  },
];

export function PerformanceStatusColour(type) {
  let color = '';
  let pallet = PERFORMANCESTATUS.find((m) => m.status === type);
  color = typeof pallet !== 'undefined' ? pallet.color : 'gray';
  return color;
}

export function ListingStatusColour(type) {
  let color = '';
  let pallet = LISTIGSTATUS.find((m) => m.status === type);
  color = typeof pallet !== 'undefined' ? pallet.color : 'gray';
  return color;
}

export const RETAILERS = [
  {
    title: 'Ascot',
    images: {
      primary: {
        x: 1000,
        l: 1000,
        w: 1000,
        dpi: 300,
        format: 'png',
        shadow: true,
        bottomMargin: 50,
      },
      secondary: { x: 1000, l: 1000, w: 1000, dpi: 300, format: 'png' },
      lifestyle: 1,
    },
    fields: ['barcode'],
    brands: ['Elizabeth Arden', 'Emily', 'Juicy', 'Curve'],
  },
  {
    title: 'Dis-Chem',
    images: {
      primary: {
        x: 1200,
        l: 1200,
        w: 1200,
        dpi: 72,
        format: 'jpg',
        centered: true,
        fillPercent: 85,
      },
      secondary: { x: 1200, l: 1200, w: 1200, dpi: 72, format: 'jpg' },
      lifestyle: 0,
      views: ['front', 'back', 'side'],
    },
    fields: ['barcode'],
    brands: [
      'Revlon',
      'Elizabeth Arden',
      'Almay',
      'Mitchum',
      'Emily',
      'Juicy',
      'Curve',
    ],
  },
  {
    title: 'Clicks',
    images: {
      primary: {
        x: 1200,
        l: 1200,
        w: 1200,
        dpi: 305,
        format: 'png',
        background: 'white',
        shadow: false,
      },
      secondary: { x: 1200, l: 1200, w: 1200, dpi: 305, format: 'png' },
      lifestyle: 0,
    },
    fields: ['barcode'],
    brands: ['Revlon', 'Elizabeth Arden', 'Mitchum', 'Emily', 'Juicy', 'Curve'],
  },
  {
    title: 'Retailibility/Edgars',
    images: {
      primary: { x: 2000, l: 2000, w: 2000, dpi: 300, shadow: false },
      secondary: { x: 2000, l: 2000, w: 2000, dpi: 300 },
      lifestyle: 0,
    },
    fields: ['barcode'],
    brands: ['Revlon', 'Elizabeth Arden', 'Emily', 'Juicy', 'Curve'],
  },
  {
    title: 'Foschini/Bash',
    images: {
      primary: { x: 2000, l: 2000, w: 2000, dpi: 150, shadow: false },
      secondary: { x: 2000, l: 2000, w: 2000, dpi: 150 },
      lifestyle: 0,
    },
    fields: ['barcode'],
    brands: ['Revlon', 'Elizabeth Arden', 'Emily', 'Juicy', 'Curve'],
  },
  {
    title: 'Truworths',
    images: {
      primary: { x: 2400, l: 2400, w: 2400, dpi: 72, format: 'jpg' },
      secondary: { x: 2400, l: 2400, w: 2400, dpi: 72, format: 'jpg' },
      lifestyle: 0,
      views: ['product', 'product_container'],
    },
    fields: ['barcode'],
    brands: ['Revlon', 'Elizabeth Arden', 'Emily', 'Juicy', 'Curve'],
  },
  {
    title: 'Woolworths',
    images: {
      primary: { x: 1200, l: 1200, w: 1200, dpi: 300 },
      secondary: { x: 1200, l: 1200, w: 1200, dpi: 300 },
      lifestyle: 0,
    },
    fields: ['style_code'],
    brands: ['Revlon', 'Elizabeth Arden', 'Emily', 'Juicy', 'Curve'],
  },
  {
    title: 'Takealot',
    images: {
      primary: {
        x: 1200,
        l: 1200,
        w: 1200,
        dpi: 72,
        format: 'png',
        shadow: false,
      },
      secondary: { x: 1200, l: 1200, w: 1200, dpi: 72, format: 'png' },
      lifestyle: 0,
    },
    fields: ['barcode'],
    brands: ['Revlon', 'Elizabeth Arden', 'Emily', 'Juicy', 'Curve'],
  },
  {
    title: 'Superbalist',
    images: {
      primary: { x: 1200, l: 1200, w: 1200, dpi: 300, shadow: false },
      secondary: { x: 1200, l: 1200, w: 1200, dpi: 300 },
      lifestyle: 0,
    },
    fields: ['barcode'],
    brands: ['Revlon', 'Elizabeth Arden', 'Emily', 'Juicy', 'Curve'],
  },
  {
    title: 'Amazon',
    images: {
      primary: { format: 'png' },
      secondary: { format: 'png' },
      lifestyle: 0,
    },
    fields: ['barcode'],
    brands: ['Elizabeth Arden'],
  },
  {
    title: 'OldSchool.co.za',
    images: {
      primary: { format: 'jpg' },
      secondary: { format: 'jpg' },
      lifestyle: 0,
    },
    fields: ['barcode'],
    brands: ['Curve'],
  },
  {
    title: 'Medirite',
    images: {
      primary: {
        x: 1200,
        l: 1200,
        w: 1200,
        dpi: 300,
        format: 'png',
        shadow: false,
        deepEtched: true,
      },
      secondary: { x: 1200, l: 1200, w: 1200, dpi: 300, format: 'png' },
      lifestyle: 0,
    },
    fields: ['barcode', 'brand'],
    brands: ['Elizabeth Arden', 'Emily', 'Juicy', 'Curve'],
  },
];

export const RETAILER = [
  'Ascot',
  'Dis-Chem',
  'Retailibility/Edgars',
  'OTC / Pharmacy',

  'Woolworths',
  'Foschini/Bash',
  'Truworths',
  'Clicks',
  'Alpha Pharm',
  'Takealot',
  'Superbalist',
  'Mopani',
  'OldSchool.co.za',
  'Instgram Boosting - Owned channel',
  'Facebook Boosting - Owned channel',
  'TikTok Promote - Owned channel',
  'YouTube Ads - Owned channel',
];

export const CHASELISTDETAILS = [
  {
    id: '1',
    MediaOwner: 'Google Search & Display',
    Site: 'GDN',
    Targeting: {
      Age: '25-45',
      Gender: '70% female, 30% male',
      Keywords: [
        'best deodorant',
        'sweat protection',
        'deodorant for sensitive skin',
      ],
      AudienceType: 'Search audience',
    },
    CampaignObjective: 'Traffic',
    CreativeExecutionSection: [
      'Display banner ads with product visuals',
      "GIF banners showing Mitchum's features",
      'Responsive Display Ads (RDAs)',
    ],
    CreativeDimensions: '1200x628, 1200x1200',
    Measurement: 'Pixels',
    MaxFileSize: '5MB',
    CreativeFormat: 'Various (JPEG Images, Videos, Logos)',
    Notes: 'Ad Copy Text: Refer to Performance Max tab for specs',
    Reference:
      'https://support.google.com/google-ads/answer/10724492#zippy=%2Cimage-specifications%2Cvideo-specifications%2Cad-creative-best-practices',
  },
  {
    id: '2',
    MediaOwner: 'Google Search & Display',
    Site: 'GDN',
    Targeting: {
      RetargetKeywords: ['Mitchum Roll-On', 'Mitchum 48-hour protection'],
      Behavior: 'Retarget visitors of the product page',
      AudienceType: 'Search audience',
    },
    CampaignObjective: 'Sales',
    CreativeExecutionSection: [
      "Google Search ads with compelling CTAs ('Buy Mitchum Roll-On Online')",
      'Display ads with product use cases (lifestyle-focused)',
    ],
    CreativeDimensions: '1200x628, 1200x1200',
    Measurement: 'Pixels',
    MaxFileSize: '5MB',
    CreativeFormat: 'Various (JPEG Images, Videos, Logos)',
    Notes: 'Ad Copy Text: Refer to Performance Max tab for specs',
    Reference:
      'https://support.google.com/google-ads/answer/10724492#zippy=%2Cimage-specifications%2Cvideo-specifications%2Cad-creative-best-practices',
  },
  {
    id: '3',
    MediaOwner: 'Meta',
    Site: 'Facebook & Instagram',
    Targeting: {
      Age: '25-45',
      Gender: 'Primarily female (70%)',
      Interests: ['Personal care', 'beauty', 'skincare', 'fitness'],
      AudienceType: 'Social media audience',
    },
    CampaignObjective: 'Awareness/Reach',
    CreativeExecutionSection: [
      'Static image ads showcasing Mitchum Roll-On',
      'Short video ads highlighting product benefits (15-30s)',
      'Carousel ads for product variety',
    ],
    CreativeDimensions: '1080x1080, 1080x1920',
    Measurement: 'Pixels',
    MaxFileSize: '30MB',
    CreativeFormat: ['JPG', 'PNG'],
    Reference: 'https://www.facebook.com/business/ads-guide/update',
  },
  {
    id: '4',
    MediaOwner: 'ByteDance',
    Site: 'TikTok',
    Targeting: {
      Age: '18-35',
      Interests: ['Fitness', 'beauty', 'skincare', 'hygiene'],
      Hashtags: ['#SkincareRoutine', '#WorkoutLife'],
      AudienceType: 'Users following influencers',
    },
    CampaignObjective: 'Awareness/Reach',
    CreativeExecutionSection: [
      'Short-form video ads (15s) demonstrating active lifestyle use of Mitchum',
      'UGC-style influencer videos showing personal use',
    ],
    CreativeDimensions: '1080x1920 (9:16)',
    Measurement: 'Pixels',
    MaxFileSize: '500MB',
    CreativeFormat: ['.mp4', '.mov'],
    Reference:
      'https://ads.tiktok.com/help/article/video-ads-specifications?lang=en',
  },
  {
    id: '5',
    MediaOwner: 'ByteDance',
    Site: 'TikTok',
    Targeting: {
      AudienceType: 'Social media audience',
    },
    CampaignObjective: 'Conversions',
    CreativeExecutionSection: [
      "Retargeting video ads with special offers (e.g., '20% Off Mitchum Roll-On')",
      'In-feed product demos with call to action (Buy Now)',
    ],
    CreativeDimensions: 'No restrictions on ratio or resolution',
    Measurement: 'Pixels',
    MaxFileSize: '10 minutes videos max',
    CreativeFormat: ['.mp4', '.mov', '.mpeg', '.3gp', '.avi'],
    Reference: 'https://ads.tiktok.com/help/article/spark-ads?lang=en',
  },

  {
    id: '6',
    MediaOwner: 'Emailer marketing',
    Site: 'Email',
    Targeting: {
      AudienceType: 'Email Targeting',
    },
    CampaignObjective: 'Conversions',

    CreativeDimensions: 'No restrictions on ratio or resolution',
    Measurement: 'Pixels',
    MaxFileSize: '10 minutes videos max',
    CreativeFormat: ['.mp4', '.mov', '.mpeg', '.3gp', '.avi'],
    Reference: 'https://ads.tiktok.com/help/article/spark-ads?lang=en',
  },

  {
    id: '7',
    MediaOwner: 'SMS Marketing ',
    Site: 'SMS',
    Targeting: {
      AudienceType: 'SMS Targeting',
    },
    CampaignObjective: 'Conversions',

    CreativeDimensions: 'No restrictions on ratio or resolution',
    Measurement: 'Pixels',
    MaxFileSize: '10 minutes videos max',
    CreativeFormat: ['.mp4', '.mov', '.mpeg', '.3gp', '.avi'],
    Reference: 'https://ads.tiktok.com/help/article/spark-ads?lang=en',
  },
  {
    id: '8',
    MediaOwner: 'Facebook Boosted ',
    Site: 'Facebook',
    Targeting: {
      AudienceType: 'Facebook Targeting',
    },
    CampaignObjective: 'Conversions',

    CreativeDimensions: 'No restrictions on ratio or resolution',
    Measurement: 'Pixels',
    MaxFileSize: '10 minutes videos max',
    CreativeFormat: ['.mp4', '.mov', '.mpeg', '.3gp', '.avi'],
    Reference: 'https://ads.tiktok.com/help/article/spark-ads?lang=en',
  },
  {
    id: '9',
    MediaOwner: 'Shopper Campaign',
    Site: 'Owned',
    Targeting: {
      AudienceType: 'Shopper Targeting',
    },
    CampaignObjective: 'Conversions',

    CreativeDimensions: 'No restrictions on ratio or resolution',
    Measurement: 'Pixels',
    MaxFileSize: '10 minutes videos max',
    CreativeFormat: ['.mp4', '.mov', '.mpeg', '.3gp', '.avi'],
    Reference: 'https://ads.tiktok.com/help/article/spark-ads?lang=en',
  },
  {
    id: '10',
    MediaOwner: 'Clicks - OTC / Pharmacy - 600 stores / 600 screens',
    Site: 'OTC',
    Targeting: {
      AudienceType: 'Shopper Targeting',
    },
    CampaignObjective: 'Conversions',

    CreativeDimensions: 'No restrictions on ratio or resolution',
    Measurement: 'Pixels',
    MaxFileSize: '10 minutes videos max',
    CreativeFormat: ['.mp4', '.mov', '.mpeg', '.3gp', '.avi'],
    Reference: '',
  },
  {
    id: '11',
    MediaOwner: 'Clicks Shop-front',
    Site: 'OTC',
    Targeting: {
      AudienceType: 'Shopper Targeting',
    },
    CampaignObjective: 'Conversions',

    CreativeDimensions: 'No restrictions on ratio or resolution',
    Measurement: 'Pixels',
    MaxFileSize: '10 minutes videos max',
    CreativeFormat: ['.mp4', '.mov', '.mpeg', '.3gp', '.avi'],
    Reference: '',
  },
  {
    id: '12',
    MediaOwner: 'Clicks - Colourline - Top Beauty Stores',
    Site: 'OTC',
    Targeting: {
      AudienceType: 'Shopper Targeting',
    },
    CampaignObjective: 'Conversions',

    CreativeDimensions: 'No restrictions on ratio or resolution',
    Measurement: 'Pixels',
    MaxFileSize: '10 minutes videos max',
    CreativeFormat: ['.mp4', '.mov', '.mpeg', '.3gp', '.avi'],
    Reference: '',
  },
  {
    id: '13',
    MediaOwner: 'Website banners & popups',
    Site: 'OTC',
    Targeting: {
      AudienceType: 'Shopper Targeting',
    },
    CampaignObjective: 'Conversions',

    CreativeDimensions: 'No restrictions on ratio or resolution',
    Measurement: 'Pixels',
    MaxFileSize: '10 minutes videos max',
    CreativeFormat: ['.mp4', '.mov', '.mpeg', '.3gp', '.avi'],
    Reference: '',
  },
  {
    id: '14',
    MediaOwner: 'In-App banners & popups',
    Site: 'OTC',
    Targeting: {
      AudienceType: 'Shopper Targeting',
    },
    CampaignObjective: 'Conversions',

    CreativeDimensions: 'No restrictions on ratio or resolution',
    Measurement: 'Pixels',
    MaxFileSize: '10 minutes videos max',
    CreativeFormat: ['.mp4', '.mov', '.mpeg', '.3gp', '.avi'],
    Reference: '',
  },
  {
    id: '15',
    MediaOwner: 'Digital Magazine',
    Site: 'OTC',
    Targeting: {
      AudienceType: 'Shopper Targeting',
    },
    CampaignObjective: 'Conversions',

    CreativeDimensions: 'No restrictions on ratio or resolution',
    Measurement: 'Pixels',
    MaxFileSize: '10 minutes videos max',
    CreativeFormat: ['.mp4', '.mov', '.mpeg', '.3gp', '.avi'],
    Reference: '',
  },
];

// "Edgars",
// 	"Clicks",
// 	"Takealot",
// 	"Woolworths",
// 	"Superbalist",
// 	"Truworths",
// 	"Foschini/Bash",

export const Avatars = [
  {
    pp: require('../assets/images/Avatars/1.png'),
    avatar: 1,
  },
  {
    pp: require('../assets/images/Avatars/2.png'),
    avatar: 2,
  },
  {
    pp: require('../assets/images/Avatars/3.png'),
    avatar: 3,
  },
  {
    pp: require('../assets/images/Avatars/4.png'),
    avatar: 4,
  },
  {
    pp: require('../assets/images/Avatars/5.png'),
    avatar: 5,
  },
  {
    pp: require('../assets/images/Avatars/6.png'),
    avatar: 6,
  },
  {
    pp: require('../assets/images/Avatars/7.png'),
    avatar: 7,
  },
  {
    pp: require('../assets/images/Avatars/8.png'),
    avatar: 8,
  },
  {
    pp: require('../assets/images/Avatars/9.png'),
  },
  {
    pp: require('../assets/images/Avatars/10.png'),
  },
  {
    pp: require('../assets/images/Avatars/11.png'),
  },
  {
    pp: require('../assets/images/Avatars/12.png'),
  },
  {
    pp: require('../assets/images/Avatars/13.png'),
  },
  {
    pp: require('../assets/images/Avatars/14.png'),
  },
  {
    pp: require('../assets/images/Avatars/15.png'),
  },
  {
    pp: require('../assets/images/Avatars/16.png'),
  },
  {
    pp: require('../assets/images/Avatars/17.png'),
  },
  {
    pp: require('../assets/images/Avatars/18.png'),
  },
  {
    pp: require('../assets/images/Avatars/19.png'),
  },
  {
    pp: require('../assets/images/Avatars/20.png'),
  },
  {
    pp: require('../assets/images/Avatars/21.png'),
  },
  {
    pp: require('../assets/images/Avatars/22.png'),
  },
  {
    pp: require('../assets/images/Avatars/23.png'),
  },
  {
    pp: require('../assets/images/Avatars/24.png'),
  },
  {
    pp: require('../assets/images/Avatars/25.png'),
  },
  {
    pp: require('../assets/images/Avatars/26.png'),
  },
  {
    pp: require('../assets/images/Avatars/27.png'),
  },
  {
    pp: require('../assets/images/Avatars/28.png'),
  },
  {
    pp: require('../assets/images/Avatars/29.png'),
  },
  {
    pp: require('../assets/images/Avatars/30.png'),
  },
  {
    pp: require('../assets/images/Avatars/31.png'),
  },
  {
    pp: require('../assets/images/Avatars/32.png'),
  },
  {
    pp: require('../assets/images/Avatars/33.png'),
  },
  {
    pp: require('../assets/images/Avatars/34.png'),
  },
  {
    pp: require('../assets/images/Avatars/35.png'),
  },
  {
    pp: require('../assets/images/Avatars/36.png'),
  },
  {
    pp: require('../assets/images/Avatars/37.png'),
  },
  {
    pp: require('../assets/images/Avatars/38.png'),
  },
  {
    pp: require('../assets/images/Avatars/39.png'),
  },
  {
    pp: require('../assets/images/Avatars/40.png'),
  },
  {
    pp: require('../assets/images/Avatars/41.png'),
  },
  {
    pp: require('../assets/images/Avatars/42.png'),
  },
  {
    pp: require('../assets/images/Avatars/43.png'),
  },
  {
    pp: require('../assets/images/Avatars/44.png'),
  },
  {
    pp: require('../assets/images/Avatars/45.png'),
  },
  {
    pp: require('../assets/images/Avatars/46.png'),
  },
  {
    pp: require('../assets/images/Avatars/47.png'),
  },
  {
    pp: require('../assets/images/Avatars/48.png'),
  },
  {
    pp: require('../assets/images/Avatars/49.png'),
  },
  {
    pp: require('../assets/images/Avatars/50.png'),
  },
];

export const driveImg = `data:image/png;base64,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`;

export function TaskStatus(type) {
  let color = '';
  // let options = {
  //   Pending: APP_COLOURS.BLUE,
  //   Done: APP_COLOURS.GREEN,
  //   Inprogress: APP_COLOURS.GREEN,
  //   '': 'transparent',
  //   Paused: APP_COLOURS.YELLOW,
  //   'Awaiting client': APP_COLOURS.ORANGE,
  //   Stuck: APP_COLOURS.RED2,
  // };

  let pallet = PROJECTSTATUS.find((m) => m.status === type);

  // console.log(pallet);
  color = typeof pallet !== 'undefined' ? pallet.color : 'gray';

  // color = typeof options[d] !== 'undefined' ? options[d] : APP_COLOURS.YELLOW;
  return color;
}

export const RETAILER_IMAGE_SPECS = {
  Amazon: [
    {
      title: 'Main Image',
      width: 2000,
      height: 2000,
      format: 'jpg',
      maxSize: '10MB',
    },
    {
      title: 'Alternative Image',
      width: 2000,
      height: 2000,
      format: 'jpg',
      maxSize: '10MB',
    },
    {
      title: 'Swatch',
      width: 100,
      height: 100,
      format: 'jpg',
      maxSize: '2MB',
    },
  ],
  Walmart: [
    {
      title: 'Primary Image',
      width: 2000,
      height: 2000,
      format: 'jpg',
      maxSize: '5MB',
    },
    {
      title: 'Secondary Image',
      width: 2000,
      height: 2000,
      format: 'jpg',
      maxSize: '5MB',
    },
  ],
  Target: [
    {
      title: 'Hero Image',
      width: 2400,
      height: 2400,
      format: 'jpg',
      maxSize: '6MB',
    },
    {
      title: 'Gallery Image',
      width: 1200,
      height: 1200,
      format: 'jpg',
      maxSize: '4MB',
    },
  ],
  // Add more retailers as needed
};

export const CAMPAIGN_PHASE_COLORS = {
  All: APP_COLOURS.BLUE,
  Strategy: '#4A90E2', // Blue
  'Awaiting Budget Approval': '#F5A623', // Orange
  Approved: '#7ED321', // Green
  'Awaiting PO': '#9013FE', // Purple
  'Campaign Booked & Approved': '#50E3C2', // Turquoise
  Chaselist: '#FF5A5F', // Red
  'Awaiting Chaselist Approval': '#BD10E0', // Magenta
  'Active Campaigns': '#4CAF50', // Different Green
  'Completed Campaigns': '#B8E986', // Light Green
};

// ============================================
// WORKFLOW / PIPELINE SYSTEM CONSTANTS
// ============================================

// Workflow Types
export const WORKFLOW_TYPES = {
  STANDARD: 'standard',
  PIPELINE: 'pipeline',
};

// Pipeline Stage Status
export const PIPELINE_STAGE_STATUS = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  BLOCKED: 'blocked',
  SKIPPED: 'skipped',
};

// Pipeline Stage Status Colors
export const PIPELINE_STAGE_COLORS = {
  pending: APP_COLOURS.GRAY,
  in_progress: APP_COLOURS.YELLOW,
  completed: APP_COLOURS.GREEN,
  blocked: APP_COLOURS.RED,
  skipped: APP_COLOURS.PLACEHOLDER,
};

// Helper function to get stage status color
export function getPipelineStageColor(status) {
  return PIPELINE_STAGE_COLORS[status] || APP_COLOURS.GRAY;
}

// Default Workflow Roles (commonly used across workflows)
export const DEFAULT_WORKFLOW_ROLES = [
  { id: 'owner', title: 'Project Owner', required: true, isExternal: false },
  { id: 'strategist', title: 'Strategist', required: false, isExternal: false },
  { id: 'copywriter', title: 'Copywriter', required: false, isExternal: false },
  { id: 'designer_static', title: 'Designer (Static)', required: false, isExternal: false },
  { id: 'designer_video', title: 'Designer (Video)', required: false, isExternal: false },
  { id: 'developer', title: 'Developer', required: false, isExternal: false },
  { id: 'community_manager', title: 'Community Manager', required: false, isExternal: false },
  { id: 'social_manager', title: 'Social Media Manager', required: false, isExternal: false },
  { id: 'project_manager', title: 'Project Manager', required: false, isExternal: false },
  { id: 'approver', title: 'Approver', required: false, isExternal: true },
  { id: 'client', title: 'Client', required: false, isExternal: true },
];

// Workflow Template Icons
export const WORKFLOW_ICONS = [
  { id: 'calendar', label: 'Calendar', icon: 'FiCalendar' },
  { id: 'edit', label: 'Content', icon: 'FiEdit3' },
  { id: 'camera', label: 'Media', icon: 'FiCamera' },
  { id: 'code', label: 'Development', icon: 'FiCode' },
  { id: 'target', label: 'Campaign', icon: 'FiTarget' },
  { id: 'users', label: 'Team', icon: 'FiUsers' },
  { id: 'package', label: 'Product', icon: 'FiPackage' },
  { id: 'trending', label: 'Analytics', icon: 'FiTrendingUp' },
  { id: 'briefcase', label: 'Business', icon: 'FiBriefcase' },
  { id: 'layers', label: 'Design', icon: 'FiLayers' },
];

// Workflow Template Colors
export const WORKFLOW_COLORS = [
  { id: 'blue', label: 'Blue', color: APP_COLOURS.BLUE },
  { id: 'green', label: 'Green', color: APP_COLOURS.GREEN },
  { id: 'orange', label: 'Orange', color: APP_COLOURS.ORANGE },
  { id: 'purple', label: 'Purple', color: APP_COLOURS.PURPLE },
  { id: 'red', label: 'Red', color: APP_COLOURS.RED },
  { id: 'yellow', label: 'Yellow', color: APP_COLOURS.YELLOW },
  { id: 'pink', label: 'Pink', color: '#F47FC0' },
  { id: 'teal', label: 'Teal', color: '#50E3C2' },
];

// Custom Field Types for Workflow Stages
export const WORKFLOW_FIELD_TYPES = [
  { id: 'text', label: 'Text', icon: 'FiType' },
  { id: 'number', label: 'Number', icon: 'FiHash' },
  { id: 'date', label: 'Date', icon: 'FiCalendar' },
  { id: 'select', label: 'Dropdown', icon: 'FiChevronDown' },
  { id: 'checkbox', label: 'Checkbox', icon: 'FiCheckSquare' },
  { id: 'file', label: 'File Upload', icon: 'FiUpload' },
  { id: 'url', label: 'URL/Link', icon: 'FiLink' },
];

// Pre-built Workflow Templates (Social Media Content Calendar example)
export const PRESET_WORKFLOW_TEMPLATES = [
  {
    id: 'social_media_content_calendar',
    title: 'Social Media Content Calendar',
    description: 'Standard workflow for monthly social media content production',
    icon: 'calendar',
    color: APP_COLOURS.BLUE,
    roles: [
      { id: 'owner', title: 'Project Owner', required: true, isExternal: false },
      { id: 'strategist', title: 'Strategist', required: true, isExternal: false },
      { id: 'copywriter', title: 'Copywriter', required: true, isExternal: false },
      { id: 'designer_static', title: 'Designer (Static)', required: false, isExternal: false },
      { id: 'designer_video', title: 'Designer (Video)', required: false, isExternal: false },
      { id: 'community_manager', title: 'Community Manager', required: false, isExternal: false },
      { id: 'social_manager', title: 'Social Media Manager', required: true, isExternal: false },
      { id: 'approver', title: 'Client Approver', required: true, isExternal: true },
    ],
    stages: [
      {
        id: 'strategy',
        title: 'Strategy & Planning',
        description: 'Define content pillars, themes, and calendar structure',
        order: 1,
        assignedRole: 'strategist',
        estimatedDays: 3,
        deliverables: ['Content strategy document', 'Theme calendar', 'Key messaging'],
        customFields: [
          { id: 'content_pillars', label: 'Number of Content Pillars', type: 'number', default: 4 },
          { id: 'campaign_theme', label: 'Campaign Theme', type: 'text', required: true },
        ],
      },
      {
        id: 'copywriting',
        title: 'Copywriting',
        description: 'Write captions, headlines, and content copy',
        order: 2,
        assignedRole: 'copywriter',
        estimatedDays: 5,
        dependsOn: ['strategy'],
        deliverables: ['Social media captions', 'Hashtag sets', 'CTA copy'],
        customFields: [
          { id: 'num_posts', label: 'Number of Posts', type: 'number', required: true },
        ],
      },
      {
        id: 'static_design',
        title: 'Static Design',
        description: 'Create static images and graphics',
        order: 3,
        assignedRole: 'designer_static',
        estimatedDays: 5,
        dependsOn: ['copywriting'],
        deliverables: ['Static post designs', 'Story graphics', 'Carousel slides'],
        customFields: [
          { id: 'num_static_assets', label: 'Number of Static Assets', type: 'number', required: true },
        ],
      },
      {
        id: 'video_design',
        title: 'Video/Motion Design',
        description: 'Create video content and animations',
        order: 4,
        assignedRole: 'designer_video',
        estimatedDays: 7,
        dependsOn: ['copywriting'],
        deliverables: ['Reels/TikToks', 'Story videos', 'Animated graphics'],
        customFields: [
          { id: 'num_video_assets', label: 'Number of Video Assets', type: 'number', required: true },
        ],
      },
      {
        id: 'internal_review',
        title: 'Internal Review',
        description: 'Internal team review and quality check',
        order: 5,
        assignedRole: 'social_manager',
        estimatedDays: 2,
        dependsOn: ['static_design', 'video_design'],
        deliverables: ['Reviewed content package', 'Feedback document'],
        customFields: [],
      },
      {
        id: 'client_approval',
        title: 'Client Approval',
        description: 'Send to client for final approval',
        order: 6,
        assignedRole: 'approver',
        estimatedDays: 3,
        dependsOn: ['internal_review'],
        isApprovalStage: true,
        approvalType: 'external',
        deliverables: ['Client sign-off'],
        customFields: [
          { id: 'approval_deadline', label: 'Approval Deadline', type: 'date' },
        ],
      },
      {
        id: 'scheduling',
        title: 'Scheduling & Publishing',
        description: 'Schedule content for publishing',
        order: 7,
        assignedRole: 'community_manager',
        estimatedDays: 1,
        dependsOn: ['client_approval'],
        deliverables: ['Scheduled posts', 'Publishing calendar'],
        customFields: [
          { id: 'publish_start_date', label: 'Publishing Start Date', type: 'date', required: true },
        ],
      },
    ],
    milestones: [
      { title: 'Strategy Complete', afterStage: 'strategy' },
      { title: 'Content Created', afterStage: 'video_design' },
      { title: 'Client Approved', afterStage: 'client_approval' },
      { title: 'Content Live', afterStage: 'scheduling' },
    ],
  },
  {
    id: 'website_development',
    title: 'Website Development',
    description: 'Standard workflow for website development projects',
    icon: 'code',
    color: APP_COLOURS.GREEN,
    roles: [
      { id: 'owner', title: 'Project Owner', required: true, isExternal: false },
      { id: 'project_manager', title: 'Project Manager', required: true, isExternal: false },
      { id: 'designer', title: 'UI/UX Designer', required: true, isExternal: false },
      { id: 'developer', title: 'Developer', required: true, isExternal: false },
      { id: 'qa', title: 'QA Tester', required: false, isExternal: false },
      { id: 'client', title: 'Client', required: true, isExternal: true },
    ],
    stages: [
      {
        id: 'discovery',
        title: 'Discovery & Requirements',
        description: 'Gather requirements and define project scope',
        order: 1,
        assignedRole: 'project_manager',
        estimatedDays: 5,
        deliverables: ['Requirements document', 'Sitemap', 'Technical specifications'],
        customFields: [
          { id: 'num_pages', label: 'Number of Pages', type: 'number', required: true },
        ],
      },
      {
        id: 'design',
        title: 'UI/UX Design',
        description: 'Create wireframes and visual designs',
        order: 2,
        assignedRole: 'designer',
        estimatedDays: 10,
        dependsOn: ['discovery'],
        deliverables: ['Wireframes', 'UI designs', 'Style guide'],
        customFields: [],
      },
      {
        id: 'design_approval',
        title: 'Design Approval',
        description: 'Client review and approval of designs',
        order: 3,
        assignedRole: 'client',
        estimatedDays: 3,
        dependsOn: ['design'],
        isApprovalStage: true,
        approvalType: 'external',
        deliverables: ['Design sign-off'],
        customFields: [],
      },
      {
        id: 'development',
        title: 'Development',
        description: 'Build the website',
        order: 4,
        assignedRole: 'developer',
        estimatedDays: 15,
        dependsOn: ['design_approval'],
        deliverables: ['Functional website', 'CMS setup'],
        customFields: [],
      },
      {
        id: 'testing',
        title: 'Testing & QA',
        description: 'Test functionality and fix bugs',
        order: 5,
        assignedRole: 'qa',
        estimatedDays: 5,
        dependsOn: ['development'],
        deliverables: ['Test report', 'Bug fixes'],
        customFields: [],
      },
      {
        id: 'launch',
        title: 'Launch',
        description: 'Deploy website to production',
        order: 6,
        assignedRole: 'developer',
        estimatedDays: 1,
        dependsOn: ['testing'],
        deliverables: ['Live website'],
        customFields: [
          { id: 'launch_date', label: 'Target Launch Date', type: 'date', required: true },
        ],
      },
    ],
    milestones: [
      { title: 'Requirements Finalized', afterStage: 'discovery' },
      { title: 'Design Approved', afterStage: 'design_approval' },
      { title: 'Development Complete', afterStage: 'development' },
      { title: 'Website Launched', afterStage: 'launch' },
    ],
  },
  {
    id: 'campaign_launch',
    title: 'Marketing Campaign',
    description: 'Standard workflow for marketing campaign execution',
    icon: 'target',
    color: APP_COLOURS.ORANGE,
    roles: [
      { id: 'owner', title: 'Project Owner', required: true, isExternal: false },
      { id: 'strategist', title: 'Campaign Strategist', required: true, isExternal: false },
      { id: 'creative', title: 'Creative Lead', required: true, isExternal: false },
      { id: 'media', title: 'Media Buyer', required: false, isExternal: false },
      { id: 'analyst', title: 'Data Analyst', required: false, isExternal: false },
      { id: 'client', title: 'Client', required: true, isExternal: true },
    ],
    stages: [
      {
        id: 'brief',
        title: 'Campaign Brief',
        description: 'Define campaign objectives and strategy',
        order: 1,
        assignedRole: 'strategist',
        estimatedDays: 3,
        deliverables: ['Campaign brief', 'Target audience', 'KPIs'],
        customFields: [
          { id: 'campaign_budget', label: 'Campaign Budget', type: 'number', required: true },
          { id: 'campaign_duration', label: 'Campaign Duration (days)', type: 'number', required: true },
        ],
      },
      {
        id: 'creative_development',
        title: 'Creative Development',
        description: 'Develop campaign creative assets',
        order: 2,
        assignedRole: 'creative',
        estimatedDays: 7,
        dependsOn: ['brief'],
        deliverables: ['Creative concepts', 'Ad designs', 'Copy'],
        customFields: [],
      },
      {
        id: 'client_approval',
        title: 'Client Approval',
        description: 'Client review and approval',
        order: 3,
        assignedRole: 'client',
        estimatedDays: 2,
        dependsOn: ['creative_development'],
        isApprovalStage: true,
        approvalType: 'external',
        deliverables: ['Client approval'],
        customFields: [],
      },
      {
        id: 'media_setup',
        title: 'Media Setup',
        description: 'Set up media placements and tracking',
        order: 4,
        assignedRole: 'media',
        estimatedDays: 3,
        dependsOn: ['client_approval'],
        deliverables: ['Media plan', 'Tracking setup'],
        customFields: [],
      },
      {
        id: 'launch',
        title: 'Campaign Launch',
        description: 'Launch the campaign',
        order: 5,
        assignedRole: 'media',
        estimatedDays: 1,
        dependsOn: ['media_setup'],
        deliverables: ['Live campaign'],
        customFields: [
          { id: 'launch_date', label: 'Launch Date', type: 'date', required: true },
        ],
      },
      {
        id: 'monitoring',
        title: 'Performance Monitoring',
        description: 'Monitor and optimize campaign',
        order: 6,
        assignedRole: 'analyst',
        estimatedDays: 14,
        dependsOn: ['launch'],
        deliverables: ['Performance reports', 'Optimization recommendations'],
        customFields: [],
      },
      {
        id: 'reporting',
        title: 'Final Reporting',
        description: 'Compile final campaign report',
        order: 7,
        assignedRole: 'analyst',
        estimatedDays: 3,
        dependsOn: ['monitoring'],
        deliverables: ['Final report', 'Learnings document'],
        customFields: [],
      },
    ],
    milestones: [
      { title: 'Strategy Approved', afterStage: 'brief' },
      { title: 'Creative Approved', afterStage: 'client_approval' },
      { title: 'Campaign Live', afterStage: 'launch' },
      { title: 'Campaign Complete', afterStage: 'reporting' },
    ],
  },
];
